/**
 * Check if an error is a connection error (backend not available)
 */
export function isConnectionError(error: unknown): boolean {
  if (error instanceof Error) {
    const message = error.message.toLowerCase();
    return (
      message.includes('connection refused') ||
      message.includes('failed to fetch') ||
      message.includes('networkerror') ||
      message.includes('network error') ||
      message.includes('err_connection_refused') ||
      message.includes('err_connection_reset')
    );
  }
  if (error instanceof TypeError && error.message.includes('Failed to fetch')) {
    return true;
  }
  return false;
}
